export default function InfoCard(p){
    // color ,content 
    return (
<div className='topCbnh'>{p.content}</div>
    );
}